import { useEffect } from 'react'
import { isEmpty } from 'lodash'
import { useNavigate, useParams } from 'react-router-dom'
import { Row, Col } from 'antd'
import { useUser } from '../../hooks/useUser'
import ContentCard from '../../components/layouts/ContentCard'
import { useUserNewsletter } from '../../hooks/useUserNewsletter'
import { HelmetHeader } from '../../components/elements/HelmetHeader'

export default function NewsletterUnsubscription() {
  const { token } = useParams()
  const navigate = useNavigate()
  const { exchangeUnsubscriptionToken, error } = useUser()
  const { newsletter, isFetched } = useUserNewsletter()

  useEffect(() => {
    if (token) {
      ;(async () => {
        try {
          await exchangeUnsubscriptionToken(token)
        } catch {
          navigate('/login')
        }
      })()
    }
  }, [token, exchangeUnsubscriptionToken, navigate])

  // The "time out" option is no longer supported: send active subscribers straight to the unsubscribe survey,
  // and already-unsubscribed users to the completion page.
  useEffect(() => {
    if (!isFetched) return
    navigate(
      newsletter.status === 'active'
        ? '/newsletter/unsubscription/survey'
        : '/newsletter/unsubscription/complete',
      { replace: true },
    )
  }, [isFetched, newsletter, navigate])

  useEffect(() => {
    if (!token && !isEmpty(error)) {
      navigate('/login')
    }
  }, [token, error, navigate])

  return (
    <Row justify="center" className="bg bg7">
      <HelmetHeader />
      <Col align="middle" flex="724px">
        <ContentCard loading />
      </Col>
    </Row>
  )
}
